import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslocoModule } from '@jsverse/transloco';

import { ActionTickerComponent } from './action-ticker.component';

import { UiPlatformButtonComponent } from '../button/button.component';

@NgModule({
  declarations: [ActionTickerComponent],
  imports: [
    CommonModule,
    UiPlatformButtonComponent,
    TranslocoModule
  ],
  exports: [ActionTickerComponent]
})
export class UiPlatformActionTickerModule {}
